import styled from '@emotion/styled'
import * as React from 'react'

import { useStatusFgColorValue } from '~theme/fgColor'
import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren & Omit<PropsOf<typeof Text>, 'as' | 'display'>

type TStyledProps = {
  errorColor: React.CSSProperties['color']
}

// get rid of the React error when passing unknown prop to the HTML element
const propForwardOptions = {
  shouldForwardProp: (propName: string) => propName !== `errorColor`,
}

const StyledAsterisk = styled(Text, propForwardOptions)<TStyledProps>`
  color: ${({ errorColor }) => errorColor};
  margin-left: 0.2rem;
`

/**
 * simple asterisk indicating that the form element (input, checkbox, ...) is required,
 * has automatically calculated error color based on the color of the background
 */
export const RequiredIndicator: React.FC<TProps> = (textProps) => {
  const errorColor = useStatusFgColorValue({ status: `error` })

  return (
    <StyledAsterisk as={`span`} display={`inline-block`} errorColor={errorColor} {...textProps}>
      *
    </StyledAsterisk>
  )
}
